











































import ViewModel from "@/views/contact/Privacy";
export default ViewModel;
